module.exports = __webpack_public_path__ + "static/media/authBg.5eb87faf.png";